import { Injectable } from "@angular/core";
import { HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { BehaviorSubject, of, throwError, Subject, Observable } from "rxjs";
import { HttpRequest, HttpHandler, HttpInterceptor } from "@angular/common/http";
import { RequestCacheService } from "./request-cache.service";
import { LoadingScreenService } from "../services/LoadingScreenService";
import { catchError, finalize, tap } from "rxjs/operators";
import { AuthService } from "../services";
import { Router } from "@angular/router";
@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  isLoading: boolean = false;
  retryTime: number = 0;
  testRequest: Subject<boolean>;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(
    private cache: RequestCacheService,
    private loadingScreenService: LoadingScreenService,
    private auth: AuthService,
    private router: Router
  ) {
    auth.freeUrls();
    this.testRequest = new Subject<boolean>();
    this.handleError = this.handleError.bind(this);
  }
  getTTL(url: string) {
    if (
      (url.includes("LookUp") &&
        !url.includes("ReadLookUp") &&
        !url.includes("ReadSaleMethodLookUp") &&
        !url.includes("Personnel/ReadUserLookupItems") &&
        !url.includes("ReadMisSetUpLookUp") &&
        !url.includes("ReadProductGoodsLookUp") &&
        !url.includes("ReadInvDailyGoodsLookUp") &&
        !url.includes("ReadBankAccountLookUp") &&
        !url.includes("PaymentMethod/PaymentMethodLookUp") &&
        !url.includes("SellCustomerGroup/ReadSellCustomerGroupLookUp") &&
        !url.includes("SalePriceType/ReadLookUp") &&
        !url.includes("PrintPolicy/GetLookupPrintPolicies") &&
        !url.includes("SalePriceType/ReadSaleMethodLookUp") &&
        !url.includes("GoodsGroup/ReadGoodsGroupLookUp")) ||
      url.includes("EntityInfo")
    )
      return 3600;
    else if (url.includes("GetMaxCode")) return -10;
    return 1;
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isValidUrl(req)) {
      if (!this.isCachable(req)) {
        if (this.cache.hasValidCachedValue(req.url)) this.cache.delete(req.url);
        return next
          .handle(req)
          .pipe(catchError(this.handleError))
          .pipe(
            finalize(() => {
              this.removeurl(req);
            })
          );
      }
      try {
        if (!this.loadingScreenService.loading) {
          this.loadingScreenService.startLoading();
        }
      } catch (e) {
        this.loadingScreenService.stopLoading();
      }
      const cachedResponse = this.cache.get(req.url);
      if (cachedResponse) {
        this.loadingScreenService.stopLoading();
        return of(new HttpResponse(cachedResponse));
      }
      return this.sendRequest(req, next);
    } else {
      const cachedResponse = this.cache.get(req.url);
      this.removeurl(req);
      if (cachedResponse) {
        this.loadingScreenService.stopLoading();
        return of(new HttpResponse(cachedResponse));
      } else return this.sendRequest(req, next);
    }
  }
  isCachable(req: HttpRequest<any>) {
    if (req.url.includes("Invoice/GetInvoiceById")) return false;
    return req.method === "GET";
  }
  isValidUrl(req: HttpRequest<any>) {
    var url = this.auth.getUrls(req.url);
    if (
      req.url.includes("GetPrinters") ||
      req.url.includes("UpdateSoftware") ||
      req.url.includes("PrinterQueue") ||
      req.url.includes("TestConnection") ||
      req.url.includes("PrintDocument")
    )
      return true;
    if (!url) this.auth.setUrls(req.url);
    return !url && !req.url.includes("MonthsName");
  }
  removeurl(req: HttpRequest<any>) {
    this.auth.removeurl(req.url);
  }
  sendRequest(req: HttpRequest<any>, next: HttpHandler): any {
    return next
      .handle(req)
      .pipe(
        tap((event) => {
          this.retryTime = 0;
          if (event instanceof HttpResponse) {
            this.cache.set(req.url, event.clone(), this.getTTL(req.url));
            this.removeurl(req);
          }
        })
      )
      .pipe(catchError(this.handleError))
      .pipe(
        finalize(() => {
          this.removeurl(req);
          this.loadingScreenService.stopLoading();
        })
      );
  }
  // Error handling
  handleError(error: any) {
    console.log(`error:`, error);
    console.log(`statusText:`, (error as HttpErrorResponse)?.statusText);
    try {
      if (
        (error instanceof HttpErrorResponse &&
          (error as HttpErrorResponse).status === 200 &&
          (error as HttpErrorResponse)?.error?.error?.message.includes("Unexpected token")) ||
        (error.status === 500 &&
          error &&
          !error?.error?.DeveloperMessage &&
          ((error?.error &&
            (error?.error?.includes("The token is expired.") || error?.error?.includes("کاربر دیگری با همین نام کاربری وارد سیستم شده است."))) ||
            (error && !error?.error && error?.includes("The token is expired."))))
      ) {
        console.log("logOute:");
        this.auth.localStorage.deleteData(`TOKEN_${AuthService.loggingUserName}`);
        this.auth.logout();

        const findModal = document.getElementsByTagName("simple-modal-holder");

        for (let index = 0; index < findModal?.length; index++) {
          findModal[index].remove();
        }
        setTimeout(() => {
          const findModal2 = document.getElementsByTagName("simple-modal-wrapper");

          for (let index = 0; index < findModal2?.length; index++) {
            findModal2[index].remove();
          }
        }, 1000);
        console.log(error.error);
        console.log("error.status", error.status);
        this.router.navigate(["auth/login"]).then(() => {
          window.location.reload();
        });
      }
    } catch (e) {
      console.log(e);
    }

    if (error?.req) this.auth.removeurl(error.req.url);
    else this.auth.removeurl(error.url);
    if (error.req?.url?.includes("/connect/token") || error.url?.includes("/connect/token")) return throwError(error);
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401 || (error.status === 503 && this.retryTime === 0)) {
        this.retryTime += 1;
        console.log(error.error);
        console.log("error.status", error.status);
        console.log("logOute:");
        this.auth.logout();
        this.auth.localStorage.deleteData(`TOKEN_${AuthService.loggingUserName}`);
        this.auth.logout();
        this.router.navigate(["auth/login"]).then(() => {
          window.location.reload();
        });
      } else {
        return throwError(error);
      }
    } else return throwError(error);
  }
}
